var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubemedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 1.98c-.21-.78-.82-1.4-1.6-1.6C14.63 0 9 0 9 0S3.37 0 1.97.38C1.2.58.6 1.2.38 1.98 0 3.4 0 6.34 0 6.34s0 2.95.38 4.37c.2.78.81 1.39 1.59 1.6 1.4.38 7.03.38 7.03.38s5.63 0 7.03-.38c.78-.21 1.39-.82 1.6-1.6.37-1.42.37-4.37.37-4.37s0-2.95-.37-4.36ZM7.16 9.02V3.67l4.7 2.67-4.7 2.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubemedium);
export default __webpack_public_path__ + "static/media/youtube.medium.8f82a166bea4c312d9fa5ea4f480a91c.svg";
export { ForwardRef as ReactComponent };